// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc90ee48","527":"30a95281"}[chunkId] + ".chunk.js";
};